module.exports = __webpack_public_path__ + "img/position-tracking.5e67840d.svg";